import type { ActionMenuOptions } from '@library/types/playerModal';
import { ActionsMenuItem } from '@library/components/menus';
import { Menu } from '@headlessui/react';
import chevronDownIcon from '@library/assets/images/icons/chevron-down-icon.svg';
import { classNames } from '@library/utils';

export interface ActionsMenuProps {
  disabled?: boolean;
  menuDisplay: string;
  options: ActionMenuOptions;
}

export const ActionsMenu = ({
  disabled = false,
  menuDisplay,
  options
}: ActionsMenuProps) => {
  const { Button, Items } = Menu;

  const renderListboxOptions = () =>
    options.map((option) => {
      const { disabled: optionDisabled, key, name, onClick } = option;
      return (
        <ActionsMenuItem
          disabled={optionDisabled}
          handleOnClick={onClick}
          key={key}
          name={name}
        />
      );
    });

  return (
    <div className="max-w-80">
      <Menu>
        {({ open }) => {
          return (
            <>
              <Button
                className={classNames(
                  open ? 'bg-soFresh-120' : 'bg-soFresh-110',
                  'border-soFresh-140 text-soClean-100 disabled:bg-soFresh-150 relative min-h-[40px] max-w-[20rem] cursor-default rounded-md border py-2 pl-3 pr-10 text-left disabled:cursor-not-allowed sm:text-sm'
                )}
                disabled={disabled}
                name={`ActionsMenuButton-${menuDisplay}`}
              >
                <span className="flex items-center text-xs">{menuDisplay}</span>

                <span className="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-2">
                  <img
                    className={classNames(open ? 'rotate-180' : '')}
                    src={chevronDownIcon}
                    alt="Chevron Down icon"
                  />
                </span>
              </Button>
              <Items className="bg-soFresh-110 ring-soFresh-100 focus:outline-hidden absolute z-10 mt-1 max-h-60 max-w-80 overflow-auto rounded-md py-1 text-base shadow-lg ring-1 sm:text-sm">
                {renderListboxOptions()}
              </Items>
            </>
          );
        }}
      </Menu>
    </div>
  );
};
